import React from 'react';
import { LogoPlaceholder } from './Placeholders';
export function Footer() {
  return <footer id="contacto" className="bg-negro pt-12 md:pt-20 pb-10 px-6 md:px-12" data-id="element-9">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-10">
        <LogoPlaceholder className="w-44 h-44 md:w-64 md:h-64 mb-8 md:mb-12" data-id="element-11" />

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 font-labrada text-crema text-base md:text-lg mb-10 md:mb-16" data-id="element-12">
          <span data-id="element-13">Instagram @lloqe.textiles</span>
          <span className="hidden md:inline text-marron" data-id="element-14">|</span>
          <span data-id="element-15">Email lloque.textiles@gmail.com</span>
          <span className="hidden md:inline text-marron" data-id="element-16">|</span>
          <span data-id="element-17">
            Ubicación Purmamarca, Quebrada de Humahuaca, Jujuy, Argentina
          </span>
        </div>

        <p className="font-labrada font-bold text-crema text-2xl md:text-3xl mb-10 md:mb-16" data-id="element-18">
          Tejidos que protegen — Quebrada de Humahuaca
        </p>

        <div className="w-full border-t border-marron pt-8" data-id="element-19">
          <p className="font-labrada font-thin text-crema/70 text-sm" data-id="element-20">
            © 2025 Lloq'e Textiles Ancestrales
          </p>
        </div>
      </div>
    </footer>;
}